import { SafeImg } from './ScrollReveal';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg overflow-hidden">
          <div className="flex-1 p-8 md:p-12 text-background-50">
            <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-background-50/20 text-background-50 mb-4 whitespace-nowrap">
              APP下载
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold mb-3">
              99漫画APP · 随时随地畅快阅读
            </h2>
            <p className="text-sm text-background-50/80 leading-relaxed mb-6 max-w-md">
              专为漫画阅读优化的移动端体验，支持下拉式流畅阅读、离线缓存、智能追更提醒。无论在地铁、咖啡厅还是睡前，打开99漫画APP就能进入你的漫画世界。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#app"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 font-semibold rounded-md hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-background-50/15 text-background-50 border border-background-50/30 font-semibold rounded-md hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-1 flex justify-center p-6 md:p-8">
            <div className="relative w-52 h-80 md:w-60 md:h-96">
              <SafeImg
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20warm%20coral%20and%20cream%20color%20scheme%2C%20Korean%20manhwa%20style%20thumbnail%20on%20screen%2C%20clean%20modern%20mobile%20UI%20design%2C%20reading%20mode%20with%20vertical%20scroll%20layout%2C%20soft%20warm%20lighting%2C%20editorial%20product%20photography%2C%20isolated%20on%20transparent%20background&width=520&height=800&seq=app-mockup-99comic&orientation=portrait"
                alt="99漫画APP界面"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}